import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import "core-js/modules/es.string.trim";
import Token from '@/config/token'; // eslint-disable-next-line import/no-cycle

import http from '@/config/http';
import api from '@/apis/eitsApi';
import { MenuItem } from '@/config/dic';
var user = {
  state: {
    // 当前激活的menu
    activeMenu: MenuItem.Home,
    // 天目token
    token: Token.getToken(),
    // 云会议token
    CMToken: Token.getCMToken(),
    // 企业号
    corpid: null,
    // vcs登录信息
    VCSLoginInfo: null,
    // 用户所在的法院
    courtNo: null,
    type: null,
    userName: null,
    userId: null,
    menuCodes: [],
    operateCodes: [],
    logo: null,
    title: null,
    skin: '0',
    productCode: process.env.VUE_APP_PRODUCTCODE,
    userIcon: '',
    reallyName: ''
  },
  mutations: {
    SET_TOKEN: function SET_TOKEN(state, token) {
      state.token = token;
      Token.setToken(token);
    },
    SET_CMTOKEN: function SET_CMTOKEN(state, token) {
      state.CMToken = token;
      Token.setCMToken(token);
    },
    SET_CORPID: function SET_CORPID(state, corpid) {
      state.corpid = corpid;
    },
    // 获取皮肤
    SET_SKIN: function SET_SKIN(state, skin) {
      sessionStorage.setItem('Hikkan-Skin', skin);
      state.skin = skin;
    },
    DEL_SKIN: function DEL_SKIN(state) {
      sessionStorage.removeItem('Hikkan-Skin');
      state.skin = '0';
    },
    DEL_TOKEN: function DEL_TOKEN(state) {
      state.token = null;
      Token.removeToken();
    },
    DEL_CMTOKEN: function DEL_CMTOKEN(state) {
      state.CMToken = null;
      Token.removeCMToken();
    },
    SET_USER_INFO: function SET_USER_INFO(state, userInfo) {
      state.corpid = userInfo.corpid;
      state.VCSLoginInfo = userInfo.vcsLoginInfo;
      state.courtNo = userInfo.courtNo;
      state.type = userInfo.type;
      state.userId = userInfo.userId;
      state.userName = userInfo.userName;
      state.menuCodes = userInfo.menuCodes;
      state.operateCodes = userInfo.operateCodes;
      state.logo = userInfo.logo;
      state.title = userInfo.title;
      state.userIcon = userInfo.userIcon;
    },
    SET_LOGIN_INFO: function SET_LOGIN_INFO(state, logiInfo) {
      state.productCode = logiInfo.productCode;
      state.userName = logiInfo.user;
    },
    DEL_USER_INFO: function DEL_USER_INFO(state) {
      state.type = null;
      state.userId = null;
      state.userName = null;
      state.menuCodes = [];
      state.operateCodes = [];
    },
    SET_USER_ICON: function SET_USER_ICON(state, userIcon) {
      state.userIcon = userIcon;
    },
    SET_USER_REALLYNAME: function SET_USER_REALLYNAME(state, reallyName) {
      state.reallyName = reallyName;
    },
    SET_MENU: function SET_MENU(state, activeMenu) {
      state.activeMenu = activeMenu;
      sessionStorage.setItem('activeMenu', activeMenu);
    },
    DEL_MENU: function DEL_MENU(state) {
      state.activeMenu = '';
      sessionStorage.removeItem('activeMenu');
    }
  },
  actions: {
    GetSkinAndRequire: function GetSkinAndRequire() {
      var skinType = 0;

      if (skinType) {// require("../../../public/theme/red.scss");
      }
    },
    commitSkin: function commitSkin(_ref, skin) {
      var commit = _ref.commit;
      commit('SET_SKIN', skin);
    },
    // 用户登录操作
    Login: function Login(_ref2, userInfo) {
      var commit = _ref2.commit;
      userInfo.name = userInfo.name.trim();
      return new Promise(function (resolve, reject) {
        http({
          method: 'post',
          url: api.LOGIN_SDK,
          data: userInfo
        }).then(function (res) {
          if (res.code === '200' || res.code === '1016' || res.code === '1018') {
            var _res$data = res.data,
                token = _res$data.token,
                CMToken = _res$data.CMToken;
            commit('SET_TOKEN', token);
            commit('SET_CMTOKEN', CMToken);
          }

          resolve(res);
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    // 用户登录操作
    FedLogin: function FedLogin(_ref3, res) {
      var commit = _ref3.commit;
      return new Promise(function (resolve) {
        if (res.code === '200' || res.code === '1016' || res.code === '1018') {
          var tokeList = res.data.Authorization.split('#');
          var token = tokeList[0];
          var CMToken = tokeList[1]; // const { Authorization, cmAuthorization } = res.data

          commit('SET_TOKEN', token);
          commit('SET_CMTOKEN', CMToken);
        }

        resolve(res);
      });
    },
    // 用户登出操作
    LogOut: function LogOut(_ref4) {
      var commit = _ref4.commit;
      return new Promise(function (resolve, reject) {
        http({
          method: 'post',
          url: api.LOGOUT_SDK
        }).then(function () {
          commit('DEL_TOKEN');
          commit('DEL_CMTOKEN');
          commit('DEL_USER_INFO');
          commit('DEL_MENU');
          commit('DEL_SKIN');
          resolve();
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    // 用户清楚后端登录信息
    ClearLoginInfo: function ClearLoginInfo(_ref5, userName) {
      var commit = _ref5.commit;
      return new Promise(function (resolve, reject) {
        http({
          method: 'post',
          url: api.CLEAR_LOGIN_INFO_SDK,
          data: {
            userName: userName
          }
        }).then(function () {
          commit('DEL_TOKEN');
          commit('DEL_CMTOKEN');
          commit('DEL_USER_INFO');
          commit('DEL_SKIN');
          commit('DEL_MENU');
          resolve();
        }).catch(function (error) {
          // 请求失败就会捕获报错信息
          reject(error);
        });
      });
    },
    // 仅前端登出，在token过期时调用
    FedLogOut: function FedLogOut(_ref6) {
      var commit = _ref6.commit;
      return new Promise(function (resolve) {
        commit('DEL_TOKEN');
        commit('DEL_CMTOKEN');
        commit('DEL_USER_INFO');
        commit('DEL_SKIN');
        commit('DEL_MENU');
        resolve();
      });
    },
    // 设置用户信息
    FedSetUserInfo: function FedSetUserInfo(_ref7, userInfo) {
      var commit = _ref7.commit;
      return new Promise(function (resolve) {
        commit('SET_USER_INFO', userInfo);
        resolve();
      });
    },
    // 设置用户头像信息
    FedSetUserIcon: function FedSetUserIcon(_ref8, userIcon) {
      var commit = _ref8.commit;
      return new Promise(function (resolve) {
        commit('SET_USER_ICON', userIcon);
        resolve();
      });
    },
    // 设置用户真实信息
    FedSetUserReallyName: function FedSetUserReallyName(_ref9, reallyName) {
      var commit = _ref9.commit;
      return new Promise(function (resolve) {
        commit('SET_USER_REALLYNAME', reallyName);
        resolve();
      });
    },
    SET_MENU: function SET_MENU(_ref10, activeMenu) {
      var commit = _ref10.commit;
      return new Promise(function (resolve) {
        commit('SET_MENU', activeMenu);
        resolve();
      });
    },
    DEL_MENU: function DEL_MENU(_ref11) {
      var commit = _ref11.commit;
      commit('DEL_MENU');
    }
  }
};
export default user;